import React, { Component } from 'react';
import {
  Link,
} from 'react-router-dom';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import Logo from '../../assets/press-hunt-logo-clear.svg';
import JournalistDatabaseIcon from '../../assets/journo-head-icon.svg';
import PrRequestIcon from '../../assets/pr-request-card-icon.svg';
import ArticleIcon from '../../assets/article-icon-head.svg';
import InfluencerIcon from '../../assets/influencer-head-icon.svg';
import FireflySubscription from '../misc/FireflySubscription';

class Navigation extends Component {

  state = {
    isActive: false,
  }

  toggleNav = () => {
    this.setState(prevState => ({
      isActive: !prevState.isActive
    }))
  }

  render() {
    return (
      <FireflySubscription>
        { ({isLoading, error, subscription, auth}) => {
          if (!auth) {
            return (
              <nav className="navbar">
                <div className="navbar-brand">
                  <div className="navbar-item logo">
                    <Link to="/">
                      <img
                        src= { Logo }
                        className="is-logo"
                        alt="Press Hunt logo"
                      />
                      <h1 className="has-text-white title is-size-4 is-logo-word">
                        Press Hunt
                      </h1>
                    </Link>
                  </div>
                  <div className="navbar-burger burger" onClick={this.toggleNav}>
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
                <div className={ this.state.isActive ? 'navbar-menu is-active' : 'navbar-menu'}>
                  <div className="navbar-end">
                    <div className="navbar-item">
                      <div className={ this.state.isActive ? 'field' : 'field is-grouped'}>

                        <div className="dropdown is-hoverable">
                          <div className="dropdown-trigger">
                            <p className={ this.state.isActive ? 'control-mobile' : 'control'}>
                              <Link to="" className={ this.state.isActive ? 'button is-clear is-nav-dropdown' : 'button is-clear is-nav-dropdown'} aria-haspopup="true" aria-controls="dropdown-menu">Product&nbsp;&nbsp;<i className="fas fa-angle-down" aria-hidden="true" style={{opacity:'.5'}}></i></Link>
                            </p>
                          </div>
                          <div className="dropdown-menu" id="dropdown-menu" role="menu">
                            <div className="dropdown-content1">

                              <a href="/journalist-database">
                                <div className="dropdown-item dropdown-list-name">
                                  <div className="nav-dropdown-title-icon-group">
                                    <img src= {JournalistDatabaseIcon} className="nav-dropdown-icon"></img>
                                    <p className="is-product-nav-title">Journalist Database</p>
                                  </div>
                                  <p className="is-product-nav-description">A database of over 500,000 journalists to feature your business</p>
                                </div>
                              </a>

                            </div>
                          </div>
                        </div>

                        <p className={ this.state.isActive ? 'control-mobile' : 'control'}>
                          <AnchorLink href="#FAQ" className={ this.state.isActive ? 'button is-clear' : 'button is-clear'}>FAQ</AnchorLink>
                        </p>
                        <p className={ this.state.isActive ? 'control-mobile' : 'control'}>
                          <Link to="/pricing" className={ this.state.isActive ? 'button is-clear' : 'button is-clear'}>Pricing</Link>
                        </p>
                        <p className={ this.state.isActive ? 'control-mobile' : 'control'}>
                          <Link to="/signin"><button className={ this.state.isActive ? 'button is-white' : 'button is-white'}>Sign in</button></Link>
                        </p>
                        <p className={ this.state.isActive ? 'control-mobile' : 'control'}>
                          <Link to="/signup"><button className={ this.state.isActive ? 'button is-stripe-nav' : 'button is-black'}>Get started&nbsp;&nbsp;<i className="fas fa-arrow-right"></i></button></Link>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </nav>
            )
          }
          if (!subscription) {
            return (
              <nav className="navbar">
                <div className="navbar-brand">
                  <div className="navbar-item logo">
                    <Link to="/">
                      <img
                        src= { Logo }
                        className="is-logo"
                        alt="Press Hunt logo"
                      />
                      <h1 className="has-text-white title is-size-4 is-logo-word">
                        Press Hunt
                      </h1>
                    </Link>
                  </div>
                  <div className="navbar-burger burger" onClick={this.toggleNav}>
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
                <div className={ this.state.isActive ? 'navbar-menu is-active' : 'navbar-menu'}>
                  <div className="navbar-end">
                    <div className="navbar-item">
                      <div className={ this.state.isActive ? 'field' : 'field is-grouped'}>

                        <div className="dropdown is-hoverable">
                          <div className="dropdown-trigger">
                            <p className={ this.state.isActive ? 'control-mobile' : 'control'}>
                              <Link to="" className={ this.state.isActive ? 'button is-clear is-nav-dropdown' : 'button is-clear is-nav-dropdown'} aria-haspopup="true" aria-controls="dropdown-menu">Product&nbsp;&nbsp;<i className="fas fa-angle-down" aria-hidden="true" style={{opacity:'.5'}}></i></Link>
                            </p>
                          </div>
                          <div className="dropdown-menu" id="dropdown-menu" role="menu">
                            <div className="dropdown-content1">

                              <a href="/journalist-database">
                                <div className="dropdown-item dropdown-list-name">
                                  <div className="nav-dropdown-title-icon-group">
                                    <img src= {JournalistDatabaseIcon} className="nav-dropdown-icon"></img>
                                    <p className="is-product-nav-title">Journalist Database</p>
                                  </div>
                                  <p className="is-product-nav-description">A database of over 500,000 journalists to feature your business</p>
                                </div>
                              </a>

                            </div>
                          </div>
                        </div>

                        <p className={ this.state.isActive ? 'control-mobile' : 'control'}>
                          <AnchorLink href="#FAQ" className={ this.state.isActive ? 'button is-clear' : 'button is-clear'}>FAQ</AnchorLink>
                        </p>
                        <p className={ this.state.isActive ? 'control-mobile' : 'control'}>
                          <Link to="/pricing" className={ this.state.isActive ? 'button is-clear' : 'button is-clear'}>Pricing</Link>
                        </p>
                        <p className={ this.state.isActive ? 'control-mobile' : 'control'}>
                          <Link to="/pricing" className={ this.state.isActive ? 'button is-black' : 'button is-black'}>Subscribe now&nbsp;&nbsp;<i className="fas fa-arrow-right"></i></Link>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </nav>
            )
          } else {
            return (
              <nav className="navbar">
                <div className="navbar-brand">
                  <div className="navbar-item logo">
                    <Link to="/">
                      <img
                        src= { Logo }
                        className="is-logo"
                        alt="Press Hunt logo"
                      />
                      <h1 className="has-text-white title is-size-4 is-logo-word">
                        Press Hunt
                      </h1>
                    </Link>
                  </div>
                  <div className="navbar-burger burger" onClick={this.toggleNav}>
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
                <div className={ this.state.isActive ? 'navbar-menu is-active' : 'navbar-menu'}>
                  <div className="navbar-end">
                  <div className="navbar-item">
                    <div className={ this.state.isActive ? 'field' : 'field is-grouped'}>

                      <div className="dropdown is-hoverable">
                        <div className="dropdown-trigger">
                          <p className={ this.state.isActive ? 'control-mobile' : 'control'}>
                            <Link to="" className={ this.state.isActive ? 'button is-clear is-nav-dropdown' : 'button is-clear is-nav-dropdown'} aria-haspopup="true" aria-controls="dropdown-menu">Product&nbsp;&nbsp;<i className="fas fa-angle-down" aria-hidden="true" style={{opacity:'.5'}}></i></Link>
                          </p>
                        </div>
                        <div className="dropdown-menu" id="dropdown-menu" role="menu">
                          <div className="dropdown-content1">

                            <a href="/journalist-database">
                              <div className="dropdown-item dropdown-list-name">
                                <div className="nav-dropdown-title-icon-group">
                                  <img src= {JournalistDatabaseIcon} className="nav-dropdown-icon"></img>
                                  <p className="is-product-nav-title">Journalist Database</p>
                                </div>
                                <p className="is-product-nav-description">A database of over 500,000 journalists to feature your business</p>
                              </div>
                            </a>

                          </div>
                        </div>
                      </div>

                      <p className={ this.state.isActive ? 'control-mobile' : 'control'}>
                        <AnchorLink href="#FAQ" className={ this.state.isActive ? 'button is-clear' : 'button is-clear'}>FAQ</AnchorLink>
                      </p>
                      <p className={ this.state.isActive ? 'control-mobile' : 'control'}>
                        <Link to="/pricing" className={ this.state.isActive ? 'button is-clear' : 'button is-clear'}>Pricing</Link>
                      </p>
                      <p className={ this.state.isActive ? 'control-mobile' : 'control'}>
                        <Link to="/dashboard" className={ this.state.isActive ? 'button is-black' : 'button is-black'}>Go to dashboard&nbsp;&nbsp;&nbsp;<i className="fas fa-chevron-right"></i></Link>
                      </p>
                    </div>
                  </div>
                  </div>
                </div>
              </nav>
            )
          }
        }}
      </FireflySubscription>
    )
  }
}

export default Navigation;
